<div class="body">
  <div class="h-full relative show-bottom-fade">
    <div class="h-full min-h-0 border-b border-white">
      <div class="max-w-xl mx-auto pt-2 px-4 container">
        <div class="header pt-2 pb-2 headermain">
          {{ translations['dishmachine_model_type'] }}
        </div>
        <div class="mb-3">
          <label class="label pb-1"
            >{{ translations['dishmachine_label'] }}
          </label>
        </div>
        <div class="dishmachine-container">
          <div
            class="dishmachine-option"
            *ngFor="let machine of accountDetails.Devices"
            [class.selected]="
              accountDetails?.selectedMachineType === machine.MachineName
            "
            (click)="onMachineSelect(machine)"
          >
            <div class="input-div">
              <input
                type="radio"
                id="{{ machine.MachineName }}"
                name="dishmachine"
                [value]="machine.MachineName"
                [checked]="
                  accountDetails?.selectedMachineType === machine.MachineName
                "
                (change)="onMachineSelect(machine)"
                (click)="$event.stopPropagation()"
              />
            </div>
            <div>
              <label for="{{ machine.MachineName }}">
                <img
                  [src]="machine.image"
                  [alt]="machine.MachineName"
                  class="dishmachine-img"
                />
              </label>
            </div>
            <div>{{ machine.MachineName }}</div>
          </div>
          <div
            class="dishmachine-option"
            [class.selected]="
              accountDetails?.selectedMachineType === 'not-sure'
            "
            (click)="onMachineSelect({ label: 'Not sure', value: 'not-sure' })"
          >
            <div class="input-div">
              <input
                type="radio"
                id="not-sure"
                name="dishmachine"
                value="not-sure"
                [checked]="accountDetails?.selectedMachineType === 'not-sure'"
                (change)="
                  onMachineSelect({ label: 'Not sure', value: 'not-sure' })
                "
                (click)="$event.stopPropagation()"
              />
            </div>
            <div>
              <label for="not-sure">{{ translations['not_sure'] }}</label>
            </div>
          </div>
          <div *ngIf="showContinueMessage" class="continue-message">
            {{ translations['no_problem'] }}
          </div>
        </div>
        <div class="button-group">
          <button type="button" class="cancel-btn" (click)="onCancel()">
            {{ translations['cancel'] }}
          </button>
          <button type="button" class="done-btn" (click)="onDone()">
            {{ translations['done'] }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
